import BasicState from "@libs/basic-view"
import MainAdminForm from "./mainAdmin"
// out
class MainAdminView extends BasicState {
  props: any 
  addRender() {  
    return <MainAdminForm {...this.props} />
  }
}
export default MainAdminView
